import React, {memo, useState} from "react";
import {updateAccount, useAccounts} from "../../Api/accounts";
import ContentBox from "../../Components/ContentBox/ContentBox";
import {customActions} from "../../Lib/simplexion-table/templates/action-buttons";
import {makeStyles} from "@material-ui/core";
import {FilterField} from "../../Components/Table/FilterField";
import {SimplexionTable} from "../../Lib/simplexion-table/SimplexionTable";
import {useTranslation} from "react-i18next";
import debug from "../../Lib/debug"
import {makeTableStyles} from "../../Components/Table/tableStyles";
import {baseTableStyles} from "../../Lib/simplexion-table/baseStyle";
import {updatableCheckBoxStyle} from "../../Lib/simplexion-table/templates/checkbox-input";
import {inputFieldStyles} from "../../Lib/simplexion-table/templates/text-input";
import {updateInputField} from "../../Lib/simplexion-table/templates/util";
import {AccountSchema} from "../../Data/account";
import LinearProgress from "@material-ui/core/LinearProgress";
import Section from "../../Lib/form/Components/Section/Section";


const useTableStyles = makeStyles(makeTableStyles(baseTableStyles, updatableCheckBoxStyle, inputFieldStyles));

const List = memo((props) => {

    debug("RENDER", "useForm", () => [" -> List_Of_Accounts", props]);

    const {t} = useTranslation("accounts");

    const path = [{label: t("accounts"), url: "/accounts"}];

    const urlNs = "/admin/accounts/";

    const {loadingStatus, data} = useAccounts();

    const tableClasses = useTableStyles();

    const [state, setState] = useState('');

    const handleFilter = val => setState(val);

    const tableConfig = {
        id: 'accounts-table',
        nameSpace: 'accounts',
        stickyHeader: true,
        sortable: true,
        styles: tableClasses,
        columns: [
            {
                accessor: 'id',
            },
            {
                accessor: 'principalName',
            },
            {
                accessor: 'fullName',
            },
            {
                accessor: 'contactName',
            },
            {
                accessor: 'job',
            },
            {
                accessor: 'translStatus',
            },
            {
                accessor: 'action',
                renderer: (...args) => customActions(true, false, urlNs, ...args),
                sortable: true,
            },
        ],
        tbodyEvent: {types: ['click'], listener: (...args) => updateInputField(updateAccount, AccountSchema, ...args)}
    };

    return (
        <ContentBox path={path} add={urlNs + "add"}>
            <Section>
                <FilterField handler={handleFilter}/>
                {loadingStatus > 0 ? <LinearProgress/> : null}
                <SimplexionTable tableConfig={tableConfig} data={data} loadingStatus={loadingStatus}
                                 filterValue={state}/>
            </Section>
        </ContentBox>
    );
});

export default List;